import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatListItem } from '@angular/material/list';


import { TrialModel } from '../overview-model';
import { AppStringsPipe } from '../../shared/pipes/appstrings.pipe';
import { AdminService } from '../admin.service';
import { Observable, Subscription } from 'rxjs';

// const data: TrialModel =
// {
//   id: 1,
//   trialNumber: 1785,
//   startDate: undefined,
//   trialStatus: TrialStatus.Created,
//   repetitions: [
//     { batch: '1', section: 'K8', pen: '1', group: '1', feed: 'Kom 41' },
//     { batch: '1', section: 'K8', pen: '2', group: '2', feed: 'Kom 42' },
//     { batch: '1', section: 'K8', pen: '3', group: '1', feed: 'Kom 41' },
//     { batch: '1', section: 'K8', pen: '4', group: '3', feed: 'Kom 43' },
//     { batch: '2', section: 'K8', pen: '5', group: '2', feed: 'Kom 42' },
//     { batch: '2', section: 'K8', pen: '6', group: '1', feed: 'Kom 41' },
//     { batch: '2', section: 'K8', pen: '7', group: '3', feed: 'Kom 43' },
//     { batch: '2', section: 'K8', pen: '8', group: '1', feed: 'Kom 41' },
//     { batch: '3', section: 'K8', pen: '9', group: '2', feed: 'Kom 42' },
//     { batch: '3', section: 'K8', pen: '10', group: '1', feed: 'Kom 41' },
//     { batch: '3', section: 'K8', pen: '11', group: '3', feed: 'Kom 43' },
//     { batch: '3', section: 'K8', pen: '12', group: '1', feed: 'Kom 41' },
//     { batch: '4', section: 'K9', pen: '13', group: '1', feed: 'Kom 41' },
//     { batch: '4', section: 'K9', pen: '14', group: '3', feed: 'Kom 43' },
//     { batch: '4', section: 'K9', pen: '15', group: '1', feed: 'Kom 41' },
//     { batch: '4', section: 'K9', pen: '16', group: '2', feed: 'Kom 42' },
//     { batch: '5', section: 'K9', pen: '17', group: '1', feed: 'Kom 41' },
//     { batch: '5', section: 'K9', pen: '18', group: '2', feed: 'Kom 42' },
//     { batch: '5', section: 'K9', pen: '19', group: '1', feed: 'Kom 41' },
//     { batch: '5', section: 'K9', pen: '20', group: '3', feed: 'Kom 43' },
//     { batch: '6', section: 'K9', pen: '21', group: '1', feed: 'Kom 41' },
//     { batch: '6', section: 'K9', pen: '22', group: '3', feed: 'Kom 43' },
//     { batch: '6', section: 'K9', pen: '23', group: '2', feed: 'Kom 42' },
//     { batch: '6', section: 'K9', pen: '24', group: '1', feed: 'Kom 41' }
//   ]
// };

@Component({
  selector: 'app-edit-trial',
  imports: [ RouterModule, MatListItem, MatFormFieldModule, FormsModule, MatInputModule, AppStringsPipe ],
  templateUrl: './edit-trial.component.html',
  // styleUrl: './edit-trial.component.scss'
})

export class EditTrialComponent implements OnInit, OnDestroy {
  protected trialData!: TrialModel;
  protected isReadOnly: boolean = true;
  private trialId!: number;
  private subscriptions = new Subscription();
  protected mydata$: Observable<TrialModel> | undefined;

  constructor(
    private adminService: AdminService,
    private route: ActivatedRoute,
    private router: Router
  ) { }


  ngOnInit(): void {
    // const id = this.route.snapshot.paramMap.get('id');
    const id = 1;
    this.trialId = Number(id);
    this.mydata$ = this.adminService.getTrial(this.trialId);
    // this.getTrialData();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  protected setEditMode() {
    this.isReadOnly = false;
  }

  private getTrialData() {

    this.subscriptions.add(
      this.adminService
        .getTrial(this.trialId)
        .subscribe((returnData: TrialModel) => {
          this.trialData = returnData;
          console.log(`Trialdata: ${this.trialData.trialNumber}`);
        }
      )
    );
  }

  // TODO: Not implpemented yet
  protected async save() {
    console.log('Save button clicked');
    await this.router.navigate([`/admin`]);
  }
}
